import React from "react";
import "../../../styles/contactos.css";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import { withNamespaces } from "react-i18next";

const Departamentos = ({ t }) => {

  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_departamentos"
      >
        {/* 1 - AMBIENTE E ORDENAMENTO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="ambiente">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cAmbiente"
              aria-expanded="true"
              aria-controls="cAmbiente"
            >
              {t('moduleContactosEstruturas:S4.A.A1.T')}
            </button>
          </h2>
          <div
            id="cAmbiente"
            className="accordion-collapse collapse"
            aria-labelledby="ambiente"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A1.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A1.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A1.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A1.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - BIOLOGIA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="biologia">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cBiologia"
              aria-expanded="true"
              aria-controls="cBiologia"
            >
              {t('moduleContactosEstruturas:S4.A.A2.T')}
            </button>
          </h2>
          <div
            id="cBiologia"
            className="accordion-collapse collapse"
            aria-labelledby="biologia"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A2.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A2.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A2.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A2.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A2.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - CIENCIAS MEDICAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="cienciasM">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cCienciasM"
              aria-expanded="true"
              aria-controls="cCienciasM"
            >
              {t('moduleContactosEstruturas:S4.A.A3.T')}
            </button>
          </h2>
          <div
            id="cCienciasM"
            className="accordion-collapse collapse"
            aria-labelledby="cienciasM"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A3.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A3.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A3.P2')}>
                    {t('moduleContactosEstruturas:S4.A.A3.P2')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A3.P3')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - CIENCIAS SOCIAIS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="cienciasS">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cCienciasS"
              aria-expanded="true"
              aria-controls="cCienciasS"
            >
              {t('moduleContactosEstruturas:S4.A.A4.T')}
            </button>
          </h2>
          <div
            id="cCienciasS"
            className="accordion-collapse collapse"
            aria-labelledby="cienciasS"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A4.P1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A4.P1.P1'))}
                  </a>
                  {t('moduleContactosEstruturas:S4.A.A4.P1.P5')}
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A4.P1.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A4.P1.P2'))}
                  </a>
                  {t('moduleContactosEstruturas:S4.A.A4.P1.P5')}
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A4.P1.P3')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A4.P1.P3'))}
                  </a>
                  {t('moduleContactosEstruturas:S4.A.A4.P1.P5')}
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A4.P1.P4')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A4.P1.P4'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A4.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A4.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A4.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A4.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A4.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 5 - COMUNICACAO E ARTE */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="comunicacao">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cComunicacao"
              aria-expanded="true"
              aria-controls="cComunicacao"
            >
              {t('moduleContactosEstruturas:S4.A.A5.T')}
            </button>
          </h2>
          <div
            id="cComunicacao"
            className="accordion-collapse collapse"
            aria-labelledby="comunicacao"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A5.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A5.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A5.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A5.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A5.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A5.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A5.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 6 - ECONOMIA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="economia">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEconomia"
              aria-expanded="true"
              aria-controls="cEconomia"
            >
              {t('moduleContactosEstruturas:S4.A.A6.T')}
            </button>
          </h2>
          <div
            id="cEconomia"
            className="accordion-collapse collapse"
            aria-labelledby="economia"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A6.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A6.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A6.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A6.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A6.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A6.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A6.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 7 - EDUCACAO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="educacao">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEducacao"
              aria-expanded="true"
              aria-controls="cEducacao"
            >
              {t('moduleContactosEstruturas:S4.A.A7.T')}
            </button>
          </h2>
          <div
            id="cEducacao"
            className="accordion-collapse collapse"
            aria-labelledby="educacao"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A7.P1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A7.P1.P1'))}
                  </a> {t('moduleContactosEstruturas:S4.A.A7.P1.P3')}
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A7.P1.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A7.P1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A7.P2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A7.P2.P1'))}
                  </a> {t('moduleContactosEstruturas:S4.A.A7.P2.P3')}
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A7.P2.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A7.P2.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A7.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A7.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A7.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 8 - ELETRONICA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="eletronica">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEletronica"
              aria-expanded="true"
              aria-controls="cEletronica"
            >
              {t('moduleContactosEstruturas:S4.A.A8.T')}
            </button>
          </h2>
          <div
            id="cEletronica"
            className="accordion-collapse collapse"
            aria-labelledby="eletronica"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A8.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A8.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A8.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A8.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A8.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A8.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A8.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 9 - ENGENHARIA E MATERIAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="engenhariaMC">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEngenhariaMC"
              aria-expanded="true"
              aria-controls="cEngenhariaMC"
            >
              {t('moduleContactosEstruturas:S4.A.A9.T')}
            </button>
          </h2>
          <div
            id="cEngenhariaMC"
            className="accordion-collapse collapse"
            aria-labelledby="engenhariaMC"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A9.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A9.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A9.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A9.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A9.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A9.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A9.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 10 - ENGENHARIA CIVIL */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="engenhariaC">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEngenhariaC"
              aria-expanded="true"
              aria-controls="cEngenhariaC"
            >
              {t('moduleContactosEstruturas:S4.A.A10.T')}
            </button>
          </h2>
          <div
            id="cEngenhariaC"
            className="accordion-collapse collapse"
            aria-labelledby="engenhariaC"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A10.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A10.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A10.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A10.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A10.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A10.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A10.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 11 - ENGENHARIA MECANICA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="engenhariaM">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEngenhariaM"
              aria-expanded="true"
              aria-controls="cEngenhariaM"
            >
              {t('moduleContactosEstruturas:S4.A.A11.T')}
            </button>
          </h2>
          <div
            id="cEngenhariaM"
            className="accordion-collapse collapse"
            aria-labelledby="engenhariaM"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A11.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A11.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A11.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A11.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A11.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A11.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A11.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 12 - FISICA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="fisica">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cFisica"
              aria-expanded="true"
              aria-controls="cFisica"
            >
              {t('moduleContactosEstruturas:S4.A.A12.T')}
            </button>
          </h2>
          <div
            id="cFisica"
            className="accordion-collapse collapse"
            aria-labelledby="fisica"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A12.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A12.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A12.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A12.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A12.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A12.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A12.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 13 - GEOCIENCIAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="geociencias">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cGeociencias"
              aria-expanded="true"
              aria-controls="cGeociencias"
            >
              {t('moduleContactosEstruturas:S4.A.A13.T')}
            </button>
          </h2>
          <div
            id="cGeociencias"
            className="accordion-collapse collapse"
            aria-labelledby="geociencias"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A13.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A13.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A13.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A13.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A13.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A13.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A13.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 14 - LINGUAS E CULTURAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="linguas">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cLinguas"
              aria-expanded="true"
              aria-controls="cLinguas"
            >
              {t('moduleContactosEstruturas:S4.A.A14.T')}
            </button>
          </h2>
          <div
            id="cLinguas"
            className="accordion-collapse collapse"
            aria-labelledby="linguas"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A14.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A14.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A14.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A14.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A14.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A14.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A14.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 15 - MATEMATICA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="matematica">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cMatematica"
              aria-expanded="true"
              aria-controls="cMatematica"
            >
              {t('moduleContactosEstruturas:S4.A.A15.T')}
            </button>
          </h2>
          <div
            id="cMatematica"
            className="accordion-collapse collapse"
            aria-labelledby="matematica"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A15.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A15.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A15.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A15.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A15.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A15.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A15.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 16 - QUIMICA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="quimica">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cQuimica"
              aria-expanded="true"
              aria-controls="cQuimica"
            >
              {t('moduleContactosEstruturas:S4.A.A16.T')}
            </button>
          </h2>
          <div
            id="cQuimica"
            className="accordion-collapse collapse"
            aria-labelledby="quimica"
            data-bs-parent="#accordionExample_departamentos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S4.A.A16.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A16.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S4.A.A16.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S4.A.A16.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S4.A.A16.P3')}>
                    {t('moduleContactosEstruturas:S4.A.A16.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S4.A.A16.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(Departamentos);

